import { Component, OnInit, inject } from "@angular/core";
import { DataAccessService } from "../core/services/data-access.service";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogTitle, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { AppComponent } from "../app.component";
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardActions, MatCardFooter } from "@angular/material/card";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatLabel, MatPrefix, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { CdkScrollable } from "@angular/cdk/scrolling";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    providers: [DataAccessService],
    imports: [MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle, FormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatPrefix, MatSuffix, MatCardActions, MatButton, MatCardFooter]
})
export class LoginComponent implements OnInit {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private dataAccess = inject(DataAccessService);
  app = inject(AppComponent);

  login = "";
  passwd = "";
  errorMsg = "";
  showPassword = false;

  ngOnInit() {
    this.dataAccess.getCsrf();
    // if ((this.dataAccess.getLoginData() as any).user_id > 0) {
    //   this.app.logout();
    // }
  }

  mouseDown() {
    this.showPassword = true;
  }

  mouseUp() {
    this.showPassword = false;
  }

  userLogIn() {
    this.dataAccess
      .getJSONPost(
        "login",
        [],
        [
          { k: "login", v: this.login },
          { k: "password", v: this.passwd },
        ]
      )
      .then((data) => {
        if (data.res == 1) {
          this.errorMsg = data.msg;
        } else {
          this.errorMsg = "";

          if (!(data.user_role_id > 0) && data.roles) {
            if (data.roles[0]) {
              data.user_role_id = data.roles[0].id;
            }
          }

          if (!data.gdpr_accepted) {
            const dialogRef = this.dialog.open(GDPRDialog, {
              disableClose: true,
              width: "1200px",
            });

            dialogRef.afterClosed().subscribe(() => {});
          }

          this.dataAccess.setLoginData(data);

          if (data.password_change_required) {
            this.router.navigate(["/settings"]); //redirect to password change
          } else {
            this.router.navigate(["/home"]);
          }
        }
      });
  }

  forgotPassword() {
    this.router.navigate(["/forgotpassword"]);
  }
}

@Component({
    selector: "gdpr-confirmation-dialog",
    templateUrl: "gdpr-confirmation-dialog.html",
    styleUrls: ["./login.component.scss"],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class GDPRDialog implements OnInit {
  dialogRef = inject<MatDialogRef<GDPRDialog>>(MatDialogRef);
  data = inject<object>(MAT_DIALOG_DATA);
  private dataAccess = inject(DataAccessService);

  ngOnInit() {
    window.scroll(0, 0);
  }

  onAccept(): void {
    this.dataAccess.getJSON("confirm_gdpr", [], []).then((data) => {
      this.dialogRef.close();
    });
  }
}
